export enum ReferralStatusTypesEnum{
    Open = 1,
    ValidationFailed = 2,
    InProgress = 4,
    Cancelled = 6,
    SubmissionFailed = 8,
    ReadyForSubmission = 9,
    ReadyForVendor = 10,
    PendingSubmission = 7,
    SubmissionInProgress = 3
}

export const ReferralStatusDisplayName: Record<number, string> = {
    [ReferralStatusTypesEnum.Open]: 'Open',
    [ReferralStatusTypesEnum.ValidationFailed]: 'Validation Failed',
    [ReferralStatusTypesEnum.InProgress]: 'In Progress',
    [ReferralStatusTypesEnum.ReadyForVendor]: 'Ready For Vendor',
    [ReferralStatusTypesEnum.ReadyForSubmission]: 'Ready For Submission',
    [ReferralStatusTypesEnum.PendingSubmission]: 'Pending Submission',
    [ReferralStatusTypesEnum.SubmissionInProgress]: 'Submission In Progress',
    [ReferralStatusTypesEnum.SubmissionFailed]: 'Submission Failed'
};